import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataTemplateCreate from "./DataTemplateCreate";
import { getData, postData } from "../../helpers/url-request";
import {
  GET_IMPORT_DEFINITION_LIST,
  SAVE_IMPORT_DEFINITION,
} from "../../helpers/url_helper";

const ImportDefinitionWizardPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [loadError, setLoadError] = useState("");
  useEffect(() => {
    if (!id) return undefined;
    let isCurrent = true;
    getData(`${GET_IMPORT_DEFINITION_LIST}/${id}`)
      .then((response) => {
        if (!isCurrent) return;
        if (!response?.status) {
          setLoadError(response?.message || "Import definition not found.");
          return;
        }
        setTemplate(response.data);
      })
      .catch(() => {
        if (isCurrent) setLoadError("Import definition could not be loaded.");
      });
    return () => {
      isCurrent = false;
    };
  }, [id]);

  const returnToDefinitions = () =>
    navigate("/system/templates?tab=import-definitions");

  const persistDefinition = async (definition, status) => {
    const response = await postData(SAVE_IMPORT_DEFINITION, {
      ...definition,
      status,
    });
    if (!response?.status)
      throw new Error(
        response?.message || "PIERS could not save the import definition."
      );
    setTemplate(response.data);
    return response.data;
  };

  if (id && loadError)
    return (
      <main className="import-definition-workspace piers-page">
        <section className="import-definition-panel">
          <h2>Import definition unavailable</h2>
          <p>{loadError}</p>
        </section>
      </main>
    );
  if (id && !template)
    return (
      <main className="import-definition-workspace piers-page">
        <section className="import-definition-panel">
          <p>Loading import definition…</p>
        </section>
      </main>
    );
  return (
    <DataTemplateCreate
      closeAction={returnToDefinitions}
      onDraftSaved={(definition) => persistDefinition(definition, "Draft")}
      onSaved={async (definition) => {
        const saved = await persistDefinition(
          definition,
          definition.status || "Active"
        );
        returnToDefinitions();
        return saved;
      }}
      template={template}
    />
  );
};

export default ImportDefinitionWizardPage;
